import React from 'react'
import { StyleProp, ViewStyle } from 'react-native'
import { HotUpdater } from '@hot-updater/react-native'
import { App } from '@config'
import { TouchableSection } from '@components'

interface VersionSectionProps {
  style?: StyleProp<ViewStyle>
}

const onPress = () => null

const VersionSection = (props: VersionSectionProps) => {
  const { style } = props

  return (
    <TouchableSection
      onPress={onPress}
      style={style}
      title={`Version: ${App.version} (${App.buildNumber}) [${HotUpdater.getBundleId()}]`}
    />
  )
}

export default VersionSection
